const languageObject = {
    button: null,
    popup: null,
    closeButton: null,
    status: -1,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;

        this.button = document.querySelector('.language-selector__container');
        this.popup = document.querySelector('.language-popup');
        this.closeButton = document.querySelector('.language-popup__close-button');

        this.button.addEventListener('click', this.showPopup.bind(this));
        this.popup.addEventListener('click', this.hidePopup.bind(this));
        this.closeButton.addEventListener('click', this.hidePopup.bind(this));
    },
    reactToResize: function () {
        this.hidePopup();
    },
    showPopup: function () {
        this.popup.classList.add('_show');
        blockingScrollObject.start();
    },
    hidePopup: function (e) {
        let event = e || window.event;
        if (event.target !== this.closeButton && event.target !== this.popup) return;

        this.popup.classList.remove('_show');
        blockingScrollObject.stop();
    }
};
